import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { Button } from "@ui/primitives/Button";
import type { UploadFile } from "@/hooks/use-direct-upload-multiple";

interface ComposerAttachmentsProps {
  files: UploadFile[];
  onRemove: (id: string) => void;
}

/** Picked images, above the field they will be sent with. Each one is removable until it goes. */
export function ComposerAttachments({ files, onRemove }: ComposerAttachmentsProps) {
  if (files.length === 0) return null;

  return (
    <ul className="mb-2 flex flex-wrap gap-2">
      {files.map((file) => (
        <li key={file.id} className="relative">
          <img
            alt={file.file.name}
            className="size-16 rounded-xl object-cover"
            data-uploading={file.status === "uploading" || undefined}
            src={file.previewUrl}
          />
          {file.status === "uploading" && (
            <span className="absolute inset-0 rounded-xl bg-white/60" aria-hidden="true" />
          )}
          {file.status === "failed" && (
            <span className="absolute inset-0 rounded-xl bg-pink-50/80 ring-1 ring-pink-400" aria-hidden="true" />
          )}
          <Button
            aria-label={t("components.views.shared.composer_attachments.remove_image", {
              name: file.file.name,
            })}
            className="absolute -top-1.5 -right-1.5 flex size-5.5 cursor-pointer items-center justify-center rounded-full bg-neutral-900 text-white outline-none focus-visible:ring-2 focus-visible:ring-red-300"
            onPress={() => onRemove(file.id)}
          >
            <Icon name="exit" size="16" />
          </Button>
        </li>
      ))}
    </ul>
  );
}
